import { Link } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import { useState, useEffect } from "react";

export default function Step1() {
  const [formData, setFormData] = useState({
    nom: '',
    prenoms: '',
    dateNaissance: '',
    sexe: '',
    contact: '',
    adresse: '',
    typePiece: "",
    numeroCNI: "",
    nni: "",
    numeroPiece: "",
    cniRecto: null,
    cniVerso: null,
    photoIdentite: null,
    carteCMU: null,
    email: '',
    telephone: ''
  });
  const [errors, setErrors] = useState({});
  const [previews, setPreviews] = useState({
    cniRecto: null,
    cniVerso: null,
    photoIdentite: null,
    carteCMU: null
  });
  // 'carte' = Carte CMU, 'recu' = Reçu d'enrôlement
  const [cmuDocType, setCmuDocType] = useState('carte');

  useEffect(() => {
    // Vider tout le localStorage pour commencer un nouveau formulaire
    localStorage.clear();
    localStorage.setItem("selectedType", "particulier");
  }, []);

  const calculateAge = (dob) => {
    if (!dob) return null;
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleChangeCNI = (e) => {
    let value = e.target.value.toUpperCase();

    // Supprimer tout sauf chiffres après CI
    value = value.replace(/^CI/, ''); // retire CI si déjà tapé
    value = value.replace(/\D/g, ''); // garde seulement les chiffres

    // Limiter à 9 chiffres
    value = value.substring(0, 9);

    setFormData(prev => ({ ...prev, numeroCNI: 'CI' + value }));
  };

  const handleChangeNNI = (e) => {
    let value = e.target.value;

    // garde seulement les chiffres
    value = value.replace(/\D/g, ''); 

    // Limiter à 11 chiffres
    value = value.substring(0, 11);

    setFormData(prev => ({ ...prev, nni: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      const file = files[0];
      setFormData(prev => ({ ...prev, [name]: file }));

      // Créer une preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviews(prev => ({ ...prev, [name]: reader.result }));
      };
      reader.readAsDataURL(file);

      if (errors[name]) {
        setErrors(prev => ({ ...prev, [name]: '' }));
      }
    }
  };

  const handleContinue = (e) => {
    let newErrors = {};

    if (!formData.nom.trim()) newErrors.nom = 'Le nom est requis.';
    if (!formData.prenoms.trim()) newErrors.prenoms = 'Le(s) prénom(s) est/sont requis.';
    if (!formData.dateNaissance) {
      newErrors.dateNaissance = 'La date de naissance est requise.';
    } else {
      const age = calculateAge(formData.dateNaissance);
      if (age < 18) {
        newErrors.dateNaissance = 'La souscription n\'est pas possible, car l\'âge minimal requis est de 18 ans.';
      }
    }
    if (!formData.sexe) newErrors.sexe = 'Le sexe est requis.';
    if (!formData.telephone.trim()) newErrors.telephone = 'Le téléphone est requis.';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      e.preventDefault();
      return;
    }

    // Sauvegarder les données dans localStorage (sans les fichiers)
    const subscriberData = {
      nom: formData.nom,
      prenoms: formData.prenoms,
      date_naissance: formData.dateNaissance,
      sexe: formData.sexe,
      contact: formData.contact,
      adresse: formData.adresse,
      type_piece: formData.typePiece,
      numero_CNI: formData.numeroCNI,
      nni: formData.nni,
      numero_Piece: formData.numeroPiece,
      email: formData.email,
      telephone: formData.telephone
    };
    localStorage.setItem('subscriberData', JSON.stringify(subscriberData));
    // console.log(localStorage.getItem('subscriberData'))

    // Sauvegarder les previews des images pour pouvoir les afficher plus tard
    localStorage.setItem('subscriberPreviews', JSON.stringify(previews));
    localStorage.setItem('subscriberCmuDocType', cmuDocType);
  };

  return (
    <div className="subscribe py-10 lg:py-16 bg-[#e4eef9]">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <h1 className="text-center text-4xl font-bold">Formulaire de souscription</h1>
        <div className="mt-10">
          <ProgressBar currentStep={1} />
          <div className="mt-8 bg-white p-6 lg:p-10 rounded-xl shadow-sm">
            <h2 className="text-xl font-bold text-secondary mb-6">1. Informations du Souscripteur</h2>
            <form className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block font-bold mb-2">Nom <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none"
                    placeholder="Votre nom"
                  />
                  {errors.nom && <p className="text-red-500 text-sm mt-1">{errors.nom}</p>}
                </div>
                <div>
                  <label className="block font-bold mb-2">Prénom(s) <span className="text-red-500">*</span></label>
                  <input
                    type="text"
                    name="prenoms"
                    value={formData.prenoms}
                    onChange={handleChange}
                    className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none"
                    placeholder="Vos prénoms"
                  />
                  {errors.prenoms && <p className="text-red-500 text-sm mt-1">{errors.prenoms}</p>}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block font-bold mb-2">Date de Naissance <span className="text-red-500">*</span></label>
                  <input
                    type="date"
                    name="dateNaissance"
                    value={formData.dateNaissance}
                    onChange={handleChange}
                    className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none"
                  />
                  {errors.dateNaissance && (
                    <p className="text-red-500 text-sm mt-1">{errors.dateNaissance}</p>
                  )}
                </div>
                <div>
                  <label className="block font-bold mb-2">Sexe <span className="text-red-500">*</span></label>
                  <div className="flex gap-4 mt-2">
                    <label className={`px-6 py-2 rounded-full cursor-pointer transition ${formData.sexe === 'M' ? 'bg-secondary text-white' : 'border border-gray-800 hover:bg-gray-100'}`}>
                      <input type="radio" name="sexe" value="M" checked={formData.sexe === 'M'} onChange={handleChange} className="sr-only" />
                      Masculin
                    </label>
                    <label className={`px-6 py-2 rounded-full cursor-pointer transition ${formData.sexe === 'F' ? 'bg-secondary text-white' : 'border border-gray-800 hover:bg-gray-100'}`}>
                      <input type="radio" name="sexe" value="F" checked={formData.sexe === 'F'} onChange={handleChange} className="sr-only" />
                      Féminin
                    </label>
                  </div>
                  {errors.sexe && <p className="text-red-500 text-sm mt-1">{errors.sexe}</p>}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block font-bold mb-2">Téléphone <span className="text-red-500">*</span></label>
                  <input
                    type="tel"
                    name="telephone"
                    value={formData.telephone}
                    onChange={handleChange}
                    className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none"
                    placeholder="Votre numéro de téléphone"
                  />
                  {errors.telephone && <p className="text-red-500 text-sm mt-1">{errors.telephone}</p>}
                </div>
                <div>
                  <label className="block font-bold mb-2">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none"
                    placeholder="Votre adresse email"
                  />
                  {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                </div>
              </div>

              <div>
                <label className="block font-bold mb-2">Adresse Géographique</label>
                <input
                  type="text"
                  name="adresse"
                  value={formData.adresse}
                  onChange={handleChange}
                  className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none"
                  placeholder="Votre adresse géographique"
                />
              </div>

              <div className={`grid grid-cols-1 ${formData.typePiece === "CNI" ? "md:grid-cols-3" : "md:grid-cols-2"} gap-4`}>
                <div>
                  <label className="block font-bold mb-2">Type de pièce</label>
                  <select name="typePiece"
                    value={formData.typePiece}
                    onChange={handleChange}
                    className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none">
                    <option value="">Sélectionner</option>
                    <option value="CNI">Carte Nationale d'Identité</option>
                    <option value="Attestation">Attestation d'identité</option>
                    <option value="Passeport">Passeport</option>
                    <option value="CC">Carte Consulaire</option>
                  </select>
                </div>

                {formData.typePiece === "CNI" ? (
                  <>
                    <div>
                      <label className="block font-bold mb-2">N° CNI</label>
                      <input
                        type="text"
                        name="numeroCNI"
                        value={formData.numeroCNI}
                        onChange={handleChangeCNI}
                        maxLength={11}
                        className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none"
                        placeholder="Numéro de CNI"
                      />
                    </div>
                    <div>
                      <label className="block font-bold mb-2">NNI</label>
                      <input
                        type="text"
                        name="nni"
                        value={formData.nni}
                        onChange={handleChangeNNI}
                        maxLength={11}
                        className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none"
                        placeholder="Numéro National d'Identité"
                      />
                    </div>
                  </>
                ) : (
                  <div>
                    <label className="block font-bold mb-2">N° Pièce</label>
                    <input
                      type="text"
                      name="numeroPiece"
                      value={formData.numeroPiece}
                      onChange={handleChange}
                      className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none"
                      placeholder="Numéro de Pièce"
                    />
                  </div>
                )}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block font-bold mb-2">Pièce Recto</label>
                  <input
                    type="file"
                    name="cniRecto"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none"
                  />
                  <p className="text-[#60215b] text-sm mt-1">* La taille du fichier doit être inférieure à 2Mo</p>
                  {previews.cniRecto && <img src={previews.cniRecto} alt="CNI Recto" className="mt-2 h-20 object-contain rounded" />}
                </div>
                <div>
                  <label className="block font-bold mb-2">Pièce Verso</label>
                  <input
                    type="file"
                    name="cniVerso"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none"
                  />
                  <p className="text-[#60215b] text-sm mt-1">* La taille du fichier doit être inférieure à 2Mo</p>
                  {previews.cniVerso && <img src={previews.cniVerso} alt="CNI Verso" className="mt-2 h-20 object-contain rounded" />}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block font-bold mb-2">Photo d'identité</label>
                  <input
                    type="file"
                    name="photoIdentite"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none"
                  />
                  <p className="text-[#60215b] text-sm mt-1">* La taille du fichier doit être inférieure à 2Mo</p>
                  {previews.photoIdentite && <img src={previews.photoIdentite} alt="Aperçu identité" className="mt-2 h-20 object-contain rounded" />}
                </div>
                <div>
                  <label className="block font-bold mb-2">Document CMU</label>
                  <div className="flex gap-4 mb-2">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="cmuDocType"
                        value="carte"
                        checked={cmuDocType === 'carte'}
                        onChange={() => setCmuDocType('carte')}
                      />
                      <span>Carte CMU</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="cmuDocType"
                        value="recu"
                        checked={cmuDocType === 'recu'}
                        onChange={() => setCmuDocType('recu')}
                      />
                      <span>Reçu d'enrôlement</span>
                    </label>
                  </div>
                  <input
                    type="file"
                    name="carteCMU"
                    accept="image/*"
                    onChange={handleFileChange}
                    className="w-full border-2 border-[#B5B8B6] rounded-2xl px-4 py-2 focus:border-primary focus:outline-none"
                  />
                  <p className="text-[#60215b] text-sm mt-1">* La taille du fichier doit être inférieure à 2Mo</p>
                  {previews.carteCMU && (
                    <img
                      src={previews.carteCMU}
                      alt={cmuDocType === 'recu' ? "Reçu d'enrôlement" : "Carte CMU"}
                      className="mt-2 h-20 object-contain rounded"
                    />
                  )}
                </div>
              </div>
            </form>

            <div className="flex justify-center gap-4 mt-8 pt-6 border-t">
              <Link
                to="/step-0"
                className="rounded-full border border-gray-300 px-6 py-3 text-gray-700 flex items-center gap-2"
              >
                ← Retour
              </Link>
              <Link
                to="/step-2"
                onClick={handleContinue}
                className="rounded-full bg-primary px-6 py-3 text-secondary font-medium flex items-center gap-2"
              >
                Continuer →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
